var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"input-group input-group--text\" :class=\"{ 'input-group--required': !!required, 'input-group--invalid': isInvalid }\">\n    <label :for=\"`input-text${_uid}`\" class=\"input-group__label\">\n      {{ label }}\n      <slot></slot>\n    </label>\n\n    <!--Mask input-->\n    <the-mask :id=\"`input-text${_uid}`\"\n              v-if=\"type === 'mask'\"\n              v-model=\"computedModel\"\n              v-bind=\"vBind\"\n              v-on=\"vOn\"\n              v-validate=\"validation\"\n              :name=\"computedName\"\n              :class=\"inputClass\"\n              class=\"input-group__input input-group__input--mask\"\n              @focus.native=\"focusEvent\"\n              @blur.native=\"blurEvent\"\n              :key=\"1\"\n    />\n\n    <!--Currency input-->\n    <money :id=\"`input-text${_uid}`\"\n           v-else-if=\"type === 'currency'\"\n           v-model=\"computedModel\"\n           v-bind=\"vBind\"\n           v-on=\"vOn\"\n           v-validate=\"validation\"\n           :name=\"computedName\"\n           :class=\"inputClass\"\n           class=\"input-group__input input-group__input--money\"\n           @focus.native=\"focusEvent\"\n           @blur.native=\"blurEvent\"\n           :key=\"2\"\n    />\n\n    <!--Textarea input-->\n    <textarea :id=\"`input-text${_uid}`\"\n              v-else-if=\"type === 'textarea'\"\n              v-model=\"computedModel\"\n              v-bind=\"vBind\"\n              v-on=\"vOn\"\n              v-validate=\"validation\"\n              :ref=\"computedRef\"\n              :name=\"computedName\"\n              :class=\"inputClass\"\n              class=\"input-group__input input-group__input--textarea\"\n              @focus=\"focusEvent\"\n              @blur=\"blurEvent\"\n              :key=\"3\"\n    />\n\n    <!--Text input-->\n    <input :id=\"`input-text${_uid}`\"\n           v-else\n           :type=\"type\"\n           v-model=\"computedModel\"\n           v-bind=\"vBind\"\n           v-on=\"vOn\"\n           v-validate=\"validation\"\n           :ref=\"computedRef\"\n           :name=\"computedName\"\n           class=\"input-group__input\"\n           :class=\"[inputClass, `input-group__input--${type}`]\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"4\"\n    />\n    <transition name=\"slide\">\n      <div class=\"input-group__error-message\" v-if=\"isInvalid\">{{ errors.first(label) }}</div>\n    </transition>\n  </div>\n";
import { Component, Prop, Watch, Vue, Inject } from 'vue-property-decorator';
import { CnpjMaskPreset, CpfCnpjMaskPreset, CpfMaskPreset, DateMaskPreset, DatetimeMaskPreset, PhoneMaskPreset, RgMaskPreset, ZipcodeMaskPreset, } from './preset';
import { MaskPresetConfig } from './MaskPresetConfig';
var InputText = /** @class */ (function (_super) {
    __extends(InputText, _super);
    function InputText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preset = new /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.mask = [];
                return _this;
            }
            return class_1;
        }(MaskPresetConfig))();
        return _this;
    }
    InputText_1 = InputText;
    InputText.addPreset = function (name, maskPreset) {
        var _a;
        InputText_1.defaultPreset = __assign({}, InputText_1.defaultPreset, (_a = {}, _a[name] = maskPreset, _a));
    };
    InputText.prototype.maskPresetEvent = function (val) {
        if (val) {
            var constructor = InputText_1.defaultPreset[val];
            if (constructor) {
                this.preset = new constructor();
            }
        }
        else {
            this.preset = new /** @class */ (function (_super) {
                __extends(class_2, _super);
                function class_2() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.mask = [];
                    return _this;
                }
                return class_2;
            }(MaskPresetConfig))();
        }
    };
    Object.defineProperty(InputText.prototype, "attrs", {
        get: function () {
            return __assign({}, this.$attrs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "listeners", {
        get: function () {
            var listeners = __assign({}, this.$listeners);
            delete listeners.input;
            return listeners;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "vBind", {
        get: function () {
            var _a = this, type = _a.type, attrs = _a.attrs;
            var extra = {};
            if (type === 'mask' && this.mask) {
                var _b = this, mask = _b.mask, masked = _b.masked, tokens = _b.tokens;
                extra = { mask: mask, masked: masked, tokens: tokens };
            }
            if (type === 'mask' && this.maskPreset) {
                var _c = this.preset, mask = _c.mask, masked = _c.masked, tokens = _c.tokens;
                extra = { mask: mask, masked: masked, tokens: tokens };
            }
            return __assign({}, attrs, extra);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "vOn", {
        get: function () {
            var listeners = this.listeners;
            return __assign({}, listeners);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "isInvalid", {
        get: function () {
            // @ts-ignore
            return this.preset.isValid === false || this.errors.first(this.label);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "computedName", {
        get: function () {
            return this.name || this.label || '-';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "computedRef", {
        get: function () {
            return this.computedName || undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "computedModel", {
        get: function () {
            if (this.maskPreset) {
                return this.preset.getterTransform(this.input);
            }
            return this.input;
        },
        set: function (input) {
            if (this.maskPreset) {
                var value = this.preset.setterTransform(input);
                if (value !== undefined) {
                    this.input = value;
                }
            }
            else {
                this.input = input;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "input", {
        get: function () {
            if (this.type === 'currency') {
                return this.value || 0;
            }
            return this.value;
        },
        set: function (val) {
            if (this.required) {
                this.$emit('input', val || '');
            }
            else {
                this.$emit('input', val || null);
            }
        },
        enumerable: true,
        configurable: true
    });
    InputText.prototype.created = function () {
        if (this.validator) {
            // @ts-ignore
            this.$validator = this.validator;
        }
    };
    InputText.prototype.focusEvent = function () {
        var el = this.$el.getElementsByTagName('input')[0];
        if (el && this.selectall)
            el.select();
        this.$emit('focus');
    };
    InputText.prototype.blurEvent = function () {
        this.$emit('blur');
    };
    var InputText_1;
    InputText.defaultPreset = {
        date: DateMaskPreset,
        datetime: DatetimeMaskPreset,
        phone: PhoneMaskPreset,
        zipcode: ZipcodeMaskPreset,
        cpf: CpfMaskPreset,
        cnpj: CnpjMaskPreset,
        cpfCnpj: CpfCnpjMaskPreset,
        rg: RgMaskPreset,
    };
    __decorate([
        Prop({ type: [String, Number], default: null }),
        __metadata("design:type", Object)
    ], InputText.prototype, "value", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "label", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "name", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "type", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "required", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "selectall", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "inputClass", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "maskPreset", void 0);
    __decorate([
        Prop({ type: [String, Array] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "mask", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "masked", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], InputText.prototype, "tokens", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], InputText.prototype, "validation", void 0);
    __decorate([
        Inject({ from: 'validator', default: null }),
        __metadata("design:type", Object)
    ], InputText.prototype, "validator", void 0);
    __decorate([
        Watch('maskPreset', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], InputText.prototype, "maskPresetEvent", null);
    InputText = InputText_1 = __decorate([
        Component({ template: template })
    ], InputText);
    return InputText;
}(Vue));
export { InputText };
//# sourceMappingURL=InputText.js.map